
import {
    INIT_MENU,
    INIT_MENU_SUCCESS,
    CHANGE_ACTIVE_MENU_FROM_LOCATION,
    CHANGE_ACTIVE_MENU_FROM_LOCATION_SUCCESS,
    TOGGLE_MENU_ITEM,
    SET_ACTIVE_MENU_ITEM,
    CLEAR_MENU,
} from './constants';

export const initMenu = () => ({
    type: INIT_MENU,
    payload: {},
});

export const initMenuSuccess = (menuItems) => ({
    type: INIT_MENU_SUCCESS,
    payload: { menuItems },
});

export const changeActiveMenuFromLocation = () => ({
    type: CHANGE_ACTIVE_MENU_FROM_LOCATION,
    payload: {},
});

export const changeActiveMenuFromLocationSuccess = (activatedMenuItemIds) => ({
    type: CHANGE_ACTIVE_MENU_FROM_LOCATION_SUCCESS,
    payload: { activatedMenuItemIds },
});

export const toggleMenuItem = (itemId) => ({
    type: TOGGLE_MENU_ITEM,
    payload: { itemId },
});

export const setActiveMenuItem = (itemId) => ({
    type: SET_ACTIVE_MENU_ITEM,
    payload: { itemId },
});

export const clearMenu = () => ({
    type: CLEAR_MENU,
    payload: {},
});
